import { Languages } from '../languages'

export enum IntroMessages {
  SECTION_TITLE = 'SECTION_TITLE',
  SECTION_1_PARAGRAPH_1 = 'SECTION_1_PARAGRAPH_1',
  MASKINGPORTEN_ANCHOR_TEXT_1 = 'MASKINGPORTEN_ANCHOR_TEXT_1',
  MASKINGPORTEN_PARAGRAPH_1 = 'MASKINGPORTEN_PARAGRAPH_1',
  TERMS_OF_USE_PARAGRAPH_1 = 'TERMS_OF_USE_PARAGRAPH_1',
  TERMS_OF_USE_LICENCE = 'TERMS_OF_USE_LICENCE',
  TERMS_OF_USE_PARAGRAPH_2 = 'TERMS_OF_USE_PARAGRAPH_2',
  SECTION_2_TITLE = 'SECTION_2_TITLE',
  SECTION_2_LI_1 = 'SECTION_2_LI_1',
  SECTION_2_LI_2 = 'SECTION_2_LI_2',
  SECTION_2_LI_3 = 'SECTION_2_LI_3',
  SECTION_2_LI_4 = 'SECTION_2_LI_4',
  SECTION_2_LI_5 = 'SECTION_2_LI_5',
  RESTRICTED_TITLE = 'RESTRICTED_TITLE',
  RESTRICTED_ANCHOR_TEXT = 'RESTRICTED_ANCHOR_TEXT',
  RESTRICTED_LINK = 'RESTRICTED_ANCHOR_LINK',
  KNOWN_ISSUES_TITLE = 'KNOWN_ISSUES_TITLE',
  KNOWN_ISSUES_LINK = 'KNOWN_ISSUES_LINK',
  CONTACT_TITLE = 'CONTACT_TITLE',
  CONTACT_EMAIL = 'CONTACT_EMAIL',
  DOWNLOAD_ANCHOR_TEXT_1 = 'DONWLOAD_ANCHOR_TEXT_1',
  DOWNLOAD_PARAGRAPH_1 = 'DOWNLOAD_PARAGRAPH_1',
  DOWNLOAD_ELHUB_LINK = 'DOWNLOAD_ELHUB_LINK',
  API_INTRO_TEXT = 'API_INTRO_TEXT',
  API_ANCHOR_TEXT_1 = 'API_ANCHOR_TEXT_1',
  API_PARAGRAPH_1 = 'API_PARAGRAPH_1',
  API_ANCHOR_TEXT_2 = 'API_ANCHOR_TEXT_2',
  API_PARAGRAPH_2 = 'API_PARAGRAPH_2'
}

export type IncludedIntroMessages = {
  [P in IntroMessages]: {
    [P in Languages]: string
  }
}

export const translatedIntroMessages: IncludedIntroMessages = {
  [IntroMessages.SECTION_TITLE]: {
    en: 'Welcome to Elhub API Services'
  },

  [IntroMessages.SECTION_1_PARAGRAPH_1]: {
    en: 'Elhub is developing APIs to support our vision of sharing more data with the public and end users. We are releasing several APIs to inform the public, empower end users with data and promote innovation in the energy market.'
  },

  [IntroMessages.MASKINGPORTEN_ANCHOR_TEXT_1]: {
    en: 'Under Maskinporten'
  },

  [IntroMessages.MASKINGPORTEN_PARAGRAPH_1]: {
    en: 'you can find guidelines on how to integrate with Maskinporten, which is a service provided by DigDir for secure machine-to-machine authorization.'
  },

  [IntroMessages.TERMS_OF_USE_PARAGRAPH_1]: {
    en: 'Our APIs and datasets are licenced by '
  },

  [IntroMessages.TERMS_OF_USE_LICENCE]: {
    en: 'CC BY 4.0.'
  },

  [IntroMessages.TERMS_OF_USE_PARAGRAPH_2]: {
    en: 'We advise all users to not cause unnecessary traffic or overload our servers.'
  },

  [IntroMessages.SECTION_2_TITLE]: {
    en: 'General information about the service'
  },

  [IntroMessages.SECTION_2_LI_1]: {
    en: 'Public APIs are open for everyone and do not require any authorization.'
  },

  [IntroMessages.SECTION_2_LI_2]: {
    en: 'APIs with personal or business sensitive data is protected and requires Maskinporten integration. Access to protected data requires a data sharing agreement with Elhub or an pre-existing right to the data in Elhub'
  },

  [IntroMessages.SECTION_2_LI_3]: {
    en: 'The service is intended to have high uptime, but there are no guarantees of availability.'
  },

  [IntroMessages.SECTION_2_LI_4]: {
    en: 'The quality of data provided by Elhub reflects the input from market parties. Elhub does not change any data before publishing.'
  },

  [IntroMessages.SECTION_2_LI_5]: {
    en: 'For public APIs there will be a rate limit to restrict frequent usage. Currently the rate limit is 5 calls per second per user. The IP address of the user will be used for rate limiting, but will not be stored.'
  },

  [IntroMessages.RESTRICTED_TITLE]: {
    en: 'Restricted'
  },

  [IntroMessages.RESTRICTED_ANCHOR_TEXT]: {
    en: 'Datasets that contain business-sensitive and private data are not open and are protected by Maskinported Authentication. Consumers who have been assigned with the relevant scope in Maskinporten by Elhub can only access the respective protected Dataset. If you have been assigned a scope, you can read more'
  },

  [IntroMessages.RESTRICTED_LINK]: {
    en: 'here.'
  },

  [IntroMessages.KNOWN_ISSUES_TITLE]: {
    en: 'Known issues'
  },

  [IntroMessages.KNOWN_ISSUES_LINK]: {
    en: 'https://elhub.no/kjente-feil-i-elhubs-api/'
  },

  [IntroMessages.CONTACT_TITLE]: {
    en: 'Contact information'
  },

  [IntroMessages.CONTACT_EMAIL]: {
    en: 'post@elhub.no'
  },

  [IntroMessages.DOWNLOAD_ANCHOR_TEXT_1]: {
    en: 'The Downloads'
  },

  [IntroMessages.DOWNLOAD_PARAGRAPH_1]: {
    en: 'section is for non-developers interested in accessing our open datasets. It provides easy access to datasets in CSV format, which can be downloaded directly from this section. There are also downloadable datasets at'
  },

  [IntroMessages.DOWNLOAD_ELHUB_LINK]: {
    en: 'elhub.no/data'
  },

  [IntroMessages.API_INTRO_TEXT]: {
    en: 'Your starting point as a developer to access and integrate ELHUB’s API services. We currently offer two APIs:'
  },

  [IntroMessages.API_ANCHOR_TEXT_1]: {
    en: 'Energy Data API'
  },

  [IntroMessages.API_PARAGRAPH_1]: {
    en: 'provides access to datasets for various ELHUB entities such as price areas, grid areas and municipalities. For more details about usage and available datasets, see '
  },

  [IntroMessages.API_ANCHOR_TEXT_2]: {
    en: 'Data Export API'
  },

  [IntroMessages.API_PARAGRAPH_2]: {
    en: 'provides file exports for different job types. Access depends on job type and data permissions. For more details about job types and usage, see '
  }

}
